
export default {
    namespaced: true,
    state: {
        /**初始化我的任务tab状态 */
        taskTab:'studyTask'
    },
    mutations: {
     /**切换我的任务tab */
     changeTaskTab(state,value){
        state.taskTab=value;
     }
    },
};